/*!
 * node-iwtax
 * 
 * Node implementation of iwtax
 * 
 * @version v0.0.1 - 2017-11-17T07:57:28-05:00
 * @revision #535bace - https://github.com/topheman/webpack-babel-starter/tree/535bace932688fcb674a123c5383ebd4c8db35b4
 * @author Oleksiy Kvashchenko
 * @copyright 2017(c) Oleksiy Kvashchenko
 * @license MIT
 * 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function convertNodeListToArray(list) {
    return [].slice.call(list);
}

function find(selector) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    return element.querySelector(selector);
}

function findAll(selector) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    return convertNodeListToArray(element.querySelectorAll(selector));
}

module.exports = { find: find, findAll: findAll };

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function addClass(el, className) {
    if (el.classList) {
        el.classList.add(className);
    } else {
        el.className += ' ' + className;
    }
}

function removeClass(el, className) {
    if (el.classList) {
        el.classList.remove(className);
    } else {
        el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
}

module.exports = {
    addClass: addClass,
    removeClass: removeClass
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _parseQuery = __webpack_require__(11);

var _parseQuery2 = _interopRequireDefault(_parseQuery);

var _find = __webpack_require__(0);

var _helpers = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setTranslationLanguageClassName() {
    var langSectionElement = (0, _find.find)('.js--lang-query');
    var langClassName = 'service--lang-';

    function setDefaultLanguage() {
        langClassName = langClassName + 'eng';
    }

    function checkQueryStringForLanguage(q) {
        if (q.lang) {
            langClassName = '' + langClassName + q.lang;
        } else {
            setDefaultLanguage();
        }
    }

    if (langSectionElement) {
        var query = (0, _parseQuery2.default)(window.location.search);
        if (query) {
            query.map(checkQueryStringForLanguage);
        } else {
            setDefaultLanguage();
        }
        (0, _helpers.addClass)(langSectionElement, langClassName);
    }
}

module.exports = setTranslationLanguageClassName;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formValidation = __webpack_require__(10);

var _formValidation2 = _interopRequireDefault(_formValidation);

var _find = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateForm() {
    var form = document.getElementsByTagName('form')[0];

    function submitForm(e) {
        var isValid = false;
        if (form) {
            if (_formValidation2.default) {
                isValid = (0, _formValidation2.default)(form);
                if (!isValid && e) {
                    e.preventDefault();
                }
            }
        }
    }

    if (form) {
        var submitBtn = (0, _find.find)('button[data-form-submit]', form);

        if (submitBtn) {
            submitBtn.addEventListener('click', submitForm);
        }
    }
}

module.exports = validateForm;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(1);

function initializeMenu() {
    var hamb = document.querySelector('.hamburger');
    var menu = document.querySelector('#menu');
    var overlay = document.querySelector('.overlay');
    var body = document.querySelector('body');
    var openMenuClass = 'open-menu';
    var scrollPosition = null;

    function checkIsOpen() {
        function hideMenu() {
            menu.style.display = 'none';
        }

        menu.isOpen = !menu.isOpen;
        if (menu.isOpen) {
            menu.style.display = 'block';
            (0, _helpers.addClass)(menu, openMenuClass);
            menu.style.translate3d = 200 + 'px,0,0';
            menu.style.transition = 'transform .2s ease-in-out';
            overlay.style.display = 'block';
            overlay.addEventListener('click', addCheckIsOpen, false);
            body.style.height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            body.style.overflow = 'hidden';
            scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
            window.scrollTo(0, 0);
        } else {
            (0, _helpers.removeClass)(menu, openMenuClass);
            overlay.style.display = 'none';
            body.style.height = 'auto';
            body.style.overflow = 'auto';
            menu.style.translate3d = -200 + 'px,0,0';
            menu.style.transition = 'transform .2s ease-in-out';

            setTimeout(hideMenu, 300);
            if (scrollPosition) {
                window.scrollTo(0, scrollPosition);
                scrollPosition = null;
            }
        }
    }

    function addCheckIsOpen() {
        checkIsOpen();
        overlay.removeEventListener('click', addCheckIsOpen);
    }

    if (menu) {
        menu.isOpen = false;

        menu.style.translate3d = -200 + 'px,0,0';
    }
    if (hamb) {
        hamb.addEventListener('click', checkIsOpen, false);
    }
}

module.exports = initializeMenu;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _find = __webpack_require__(0);

function initializePaypalButton() {
    var form = document.querySelector('.js-paypal-form');
    var maps = document.querySelector('.maps');

    function redirectToPaypal(e) {
        function addParamToQuery(input) {
            query.push(input.name + '=' + input.value);
        }
        e.preventDefault();
        var query = [];
        var hiddenInputs = (0, _find.findAll)('input[type=\'hidden\']', form);
        hiddenInputs.map(addParamToQuery);
        var queryStr = '/search?' + query.join('&');
        window.location.href = form.getAttribute('action') + queryStr;
    }

    function setIframePointerEventsToAuto() {
        (0, _find.find)('iframe', maps).style.pointerEvents = 'auto';
    }

    function setIframePointerEventsToNone() {
        (0, _find.find)('iframe', maps).style.pointerEvents = 'none';
    }

    if (form) {
        form.addEventListener('click', redirectToPaypal, false);
    }

    if (maps) {
        maps.addEventListener('click', setIframePointerEventsToAuto, false);
        maps.addEventListener('mouseleave', setIframePointerEventsToNone, false);
    }
}

module.exports = initializePaypalButton;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ready(callbacks) {
    function runOnReady(fn) {
        var callback = fn || function fakeReady() {};
        function attachEventReady() {
            if (document.readyState !== 'loading') {
                callback();
            }
        }
        if (document.readyState !== 'loading') {
            callback();
        } else if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            document.attachEvent('onreadystatechange', attachEventReady);
        }
    }

    callbacks.map(runOnReady);
}

module.exports = ready;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ready = __webpack_require__(8);

var _ready2 = _interopRequireDefault(_ready);

var _contact = __webpack_require__(5);

var _contact2 = _interopRequireDefault(_contact);

var _menu = __webpack_require__(6);

var _menu2 = _interopRequireDefault(_menu);

var _about = __webpack_require__(4);

var _about2 = _interopRequireDefault(_about);

var _paypal_button = __webpack_require__(7);

var _paypal_button2 = _interopRequireDefault(_paypal_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _ready2.default)([_paypal_button2.default, _menu2.default, _contact2.default, _about2.default]);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isEmail = __webpack_require__(13);

var _isEmail2 = _interopRequireDefault(_isEmail);

var _find = __webpack_require__(0);

var _helpers = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(form) {
    var rules = {
        text: {
            type: 'text',
            rule: /^\w{1,}$/,
            error: ''
        },
        alpha: {
            type: 'alpha',
            rule: /^[a-zA-Z.-_]{2,}$/,
            error: ''
        },
        email: {
            type: 'email',
            // rule: /^.*@\w{2,}.\w{2,}$/,
            rule: _isEmail2.default,
            error: ''
        },
        textarea: {
            type: 'text',
            rule: /^\w{1,}$/,
            error: ''
        }
    };
    var isValid = true;
    var errorAttr = 'data-error';

    var inputs = (0, _find.findAll)('input,textarea', form);

    function showUiError(error) {
        if (error && error.style) {
            error.style.display = 'block';
        }
    }

    function hideUiError(error) {
        if (error && error.style) {
            error.style.display = 'none';
        }
    }

    function showError(field, errorType) {
        var errors = (0, _find.findAll)('[' + errorAttr + ']', field.parentNode);

        function checkError(error) {
            if (error && error.getAttribute(errorAttr) === errorType) {
                showUiError(error);
            } else {
                hideUiError(error);
            }
        }

        if (errors && errors.length) {
            errors.map(checkError);
        }
    }

    function hideError(field) {
        var selector = '[' + errorAttr + ']';
        var errors = (0, _find.findAll)(selector, field.parentNode);
        if (errors && errors.length) {
            errors.map(hideUiError);
        }
    }

    function validateFields(field) {
        var errorType = field.getAttribute('data-error-type');

        if (rules[field.type]) {
            var isFieldValid = void 0;
            if (field.value.trim().length < 1 || field.hasOwnProperty('innerText') && field.innerText.trim().length < 1) {
                errorType = 'required';
                isFieldValid = false;
            } else if (rules[errorType]) {
                if (typeof rules[errorType] === 'function') {
                    isFieldValid = rules[errorType](field.value.trim());
                } else {
                    isFieldValid = rules[errorType].rule.test(field.value.trim());
                }
            } else {
                isFieldValid = true;
            }

            if (!isFieldValid) {
                isValid = false;
                showError(field, errorType);
                (0, _helpers.addClass)(field, 'error');
            } else {
                hideError(field);
                (0, _helpers.removeClass)(field, 'error');
            }
        }
    }

    function filterRequired(input) {
        return input.required;
    }

    var required = inputs.filter(filterRequired);

    required.map(validateFields);
    return isValid;
}

module.exports = validate;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function parseQuery(str) {
    if (str.charAt(0) === '?') {
        str = str.substring(1, str.length);
    }

    function extractParams(i) {
        var params = i.split('=');

        if (params && params.length) {
            var item = {};
            item[params[0]] = params[1];
            return item;
        }
        return true;
    }

    var parts = str.split('&').map(extractParams);
    return parts;
}

module.exports = parseQuery;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(2);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(2);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(3);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(12);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(14);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__(2);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(3);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app-bundle.js